import { Link, Table, TableBody, TableHead } from '@mui/material';
import { StyledTableCell, StyledTableRow } from '../StyledTable';
import React from 'react';
import { XpmJob } from '../types/XpmType';

export type JobsTableDialogsProps = {
  jobs: XpmJob[];
};

export default function JobsTable(props: JobsTableDialogsProps) {
  const { jobs } = props;

  if (!jobs || jobs.length == 0) {
    return <div style={{ margin: 8 }}>No XPM jobs found for this client.</div>;
  }

  return (
    <div>
      <Table>
        <TableHead style={{ backgroundColor: 'rgb(237, 237, 237)' }}>
          <StyledTableRow>
            <StyledTableCell align="center">Name</StyledTableCell>
            <StyledTableCell align="center">State</StyledTableCell>
            <StyledTableCell align="center">Link</StyledTableCell>
            {/*<StyledTableCell align="center">Actions</StyledTableCell>*/}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {jobs.map((job, index) => (
            <StyledTableRow key={`transaction${index}`}>
              <StyledTableCell align="left">{job.name}</StyledTableCell>
              <StyledTableCell align="left">{job.state}</StyledTableCell>
              <StyledTableCell align="left">
                <Link rel="noopener noreferrer" target="_blank" href={job.webUrl}>
                  {job.name}
                </Link>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
